const bogusWebCrypto = [
    { hash: 'SHA-256', name: 'HMAC' },
    true,
    ['sign'],
];
export default bogusWebCrypto;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/runtime/bogus.js